import { AddAxiosInterceptors } from "../http/AddAxiosInterceptor";
import { ConfigurationProvider } from "../configuration/ConfigurationProvider";
import { IdentityProvider } from "../identity/IdentityProvider";
import { PageFileResolver } from "../files/PageFileResolver";

export class Startup {
  static async Run(app: () => void) {

     AddAxiosInterceptors();


    await ConfigurationProvider.init();

    await IdentityProvider.init();

    // attachments (PageFiles) need the bearer token: resolve <img data-ark-src> and attachment links app-wide
    PageFileResolver.Global.start();

    app();
  }
}
